export default __webpack_public_path__ + "static/media/webooks.aa99521e.png";